export enum CameraResolutionActionsTypes {
  "LIST_CAMERA_RESOLUTION" = "LIST_CAMERA_RESOLUTION"
}

export enum CameraResolutionMutationsTypes {
  "SET_CAMERA_RESOLUTION" = "SET_CAMERA_RESOLUTION"
}

export enum CameraResolutionGettersTypes {
  "CAMERA_RESOLUTION_BY_ID" = "CAMERA_RESOLUTION_BY_ID",
  "CAMERA_RESOLUTION_ALL_ID" = "CAMERA_RESOLUTION_ALL_ID"
}
